(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cp-cart-add]');
    if (!button) return;
    event.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    button.disabled = true;
    button.classList.add('is-loading');
    fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.cpCartAdd), quantity: 1 }],
        sections: drawer ? drawer.getSectionsToRender().map((section) => section.id) : [],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((state) => {
        if (state.status) throw new Error(state.description || state.message);
        if (drawer && state.sections) drawer.renderContents(state);
        else window.location = window.routes ? window.routes.cart_url : '/cart';
      })
      .catch(() => {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = 'Try again';
      });
  });

  // Frequently Bought Together: option picker updates the card, arrows page the carousel.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-cp-fbt-select]');
    if (!select) return;
    const card = select.closest('[data-cp-fbt-card]');
    const option = select.options[select.selectedIndex];
    card.querySelector('[data-cp-cart-add]').dataset.cpCartAdd = option.value;
    card.querySelector('[data-cp-fbt-price]').textContent = option.dataset.price;
    card.querySelector('[data-cp-fbt-compare]').textContent = option.dataset.compare;
    const img = card.querySelector('.cp-fbt__img');
    if (img && option.dataset.img) {
      img.removeAttribute('srcset');
      img.src = option.dataset.img;
    }
  });

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-cp-fbt-prev], [data-cp-fbt-next]');
    if (!arrow) return;
    const track = arrow.closest('[data-cp-fbt]').querySelector('[data-cp-fbt-track]');
    const step = track.clientWidth + 12;
    track.scrollBy({ left: arrow.hasAttribute('data-cp-fbt-next') ? step : -step, behavior: 'smooth' });
  });

  const syncArrows = (track) => {
    const box = track.closest('[data-cp-fbt]');
    const prev = box.querySelector('[data-cp-fbt-prev]');
    const next = box.querySelector('[data-cp-fbt-next]');
    if (!prev || !next) return;
    prev.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  };

  // Free-shipping bar: Liquid renders it in the store currency; convert for other currencies.
  const syncShipping = () => {
    const ship = document.querySelector('[data-cp-ship]');
    const currency = window.Shopify && window.Shopify.currency;
    if (!ship || !currency || Number(currency.rate) === 1) return;
    const key = `${ship.dataset.total}-${ship.dataset.count}-${currency.active}`;
    if (ship.dataset.cpSynced === key) return;
    ship.dataset.cpSynced = key;
    const min = Math.round(Number(ship.dataset.min) * Number(currency.rate));
    const total = Number(ship.dataset.total);
    const free = total >= min || Number(ship.dataset.count) >= 2;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency.active });
    ship.querySelector('[data-cp-ship-fill]').style.width = `${free ? 100 : Math.min(100, (total / min) * 100)}%`;
    ship.querySelector('[data-cp-ship-text]').innerHTML = free
      ? '&#127881; You\'ve unlocked <strong>FREE Shipping</strong>'
      : `You're <strong>${money.format((min - total) / 100)}</strong> away from <strong>FREE Shipping</strong> &#128230;`;
  };

  // Free-delivery threshold in banners: Liquid prints a dollar fallback; show the live converted amount, rounded up.
  const syncThresholds = () => {
    const currency = window.Shopify && window.Shopify.currency;
    if (!currency || Number(currency.rate) === 1) return;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency.active,
      maximumFractionDigits: 0,
    });
    document.querySelectorAll('[data-cp-gbp]').forEach((el) => {
      el.textContent = money.format(Math.ceil((Number(el.dataset.cpGbp) / 100) * Number(currency.rate)));
    });
  };
  syncThresholds();

  const syncDrawer = () => {
    syncShipping();
    document.querySelectorAll('[data-cp-fbt-track]').forEach((track) => {
      syncArrows(track);
      if (!track.dataset.cpBound) {
        track.dataset.cpBound = '1';
        track.addEventListener('scroll', () => syncArrows(track), { passive: true });
      }
    });
  };

  const drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) {
    new MutationObserver(syncDrawer).observe(drawerEl, { childList: true, subtree: true });
    syncDrawer();
    if (/[?&]cp_open_cart=1/.test(window.location.search)) {
      window.addEventListener('load', () => drawerEl.open && drawerEl.open());
    }
  }

  const bar = document.querySelector('.utility-bar');
  if (!bar) return;
  try {
    if (sessionStorage.getItem('cpAnnouncementClosed') === '1') {
      bar.closest('.shopify-section')?.classList.add('cp-announcement-hidden');
      return;
    }
  } catch (e) {}
  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'cp-announcement-close';
  close.setAttribute('aria-label', 'Close announcement');
  close.innerHTML = '&times;';
  close.addEventListener('click', () => {
    bar.closest('.shopify-section')?.classList.add('cp-announcement-hidden');
    try {
      sessionStorage.setItem('cpAnnouncementClosed', '1');
    } catch (e) {}
  });
  bar.style.position = 'relative';
  bar.appendChild(close);
})();
